import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import SubscriptionRow from "./SubscriptionRow";

const SubscriptionTable = ({ data, onEdit, onDelete, onUpdate }) => {
  return (
    <TableContainer component={Paper} elevation={3}>
      <Table>
        <TableHead sx={{ bgcolor: "primary.main" }}>
          <TableRow>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Plan</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">Duration</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">Price</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">Status</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }}>Features</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }} align="right">Last Updated</TableCell>
            <TableCell sx={{ color: "white", fontWeight: "bold" }} align="right">Action</TableCell>
          </TableRow>
        </TableHead>
       <TableBody>
  {data.length === 0 ? (
    <TableRow>
      <TableCell colSpan={6} align="center">
        Empty subscription plans
      </TableCell>
    </TableRow>
  ) : (
    data.map((sub) => (
      <SubscriptionRow
        key={sub.id}
        subscription={sub}
        onEdit={() => onEdit(sub)}
        onDelete={(deletedId) => onDelete(deletedId)} // ✅ only ID passed
        onUpdate={onUpdate}
      />
    ))
  )}
</TableBody>

      </Table>
    </TableContainer>
  );
};

export default SubscriptionTable;
